import React from 'react';
import styled from 'styled-components';

import {Icon} from '../../elements/Icon/Icon';

export const FormSelectArrowIcon = () => (
    <FormSelectArrowIconContainer>
        <Icon color="var(--default-text-color)" name="KeyboardArrowDown" />
    </FormSelectArrowIconContainer>
);

const FormSelectArrowIconContainer = styled.div`
    background-image: linear-gradient(
        to right,
        var(--form-box-background-transparent-color),
        var(--form-box-background-color),
        var(--form-box-background-color)
    );
    border-radius: 0 var(--radius-form-control) var(--radius-form-control) 0;
    bottom: 1px;
    display: block;
    pointer-events: none;
    position: absolute;
    right: 1px;
    top: 1px;
    width: 60px;

    ${Icon.Wrapper} {
        position: absolute;
        right: var(--space-sm);
        top: 50%;
        transform: translateY(-50%);
    }
`;
FormSelectArrowIcon.Container = FormSelectArrowIconContainer;
